import {
  useWSSnackbar,
  WSPageToolbarAction
} from "@wingspanhq/fe-component-library";
import { UserStatus } from "@wingspanhq/users/dist/lib/interfaces";
import { PayerPayeeStatus } from "@wingspanhq/payments/dist/interfaces/payerPayee";
import { isPayeeProvidedInfo } from "./utils";
import { buildPayeeEditTaxInfoPath } from "../../utils";
import { useCreatePayeeEngagementModal } from "../../components/CreatePayeeEngagementModal/useCreateEngagementModal";
import { useIsEngagementsActive } from "../../../../shared/hooks/useIsEngagementsActive";
import { useEditContractorModal } from "../../components/UpdateContractorModal/useUpdateContractorModal";
import { useInternalNotesModal } from "../../components/InternalNotesModal/useInternalNotesModal";
import { useArchiveContractorModal } from "../../components/ArchiveContractorModal";
import { getPayeeNames } from "../../selectors/getPayeeNames";
import { useMutationUpdatePayee } from "../../../../query/payee/mutations/useMutationUpdatePayee";
import { useXWingspanPayerId } from "./useXWingspanPayerId";
import { useGoTo } from "../../../../shared/utils/useGoTo";
import { useHistory } from "react-router-dom";
import { IPayeeResponse } from "@wingspanhq/payments/dist/interfaces";
import { useAuthorizedScopeGroups } from "../../../../shared/utils/teamUtils";
import { useMutationResendPayeeInvite } from "../../../../query/payee/mutations/useMutationResendPayeeInvite";
import { IPayeeRow } from "../../../../services/search/payee/getPayeeRows";

export const usePayeeRowActions = () => {
  const { openSnackbar } = useWSSnackbar();
  const history = useHistory();
  const modalAddEngagement = useCreatePayeeEngagementModal();
  const isEngagementsActive = useIsEngagementsActive();
  const modalEditContractor = useEditContractorModal();
  const [updatePayee, updatePayeeMeta] = useMutationUpdatePayee();
  const modalInternalNotes = useInternalNotesModal();
  const modalArchiveContractor = useArchiveContractorModal();
  const organizationId = useXWingspanPayerId();
  const isOrgContext = !!organizationId;
  const goTo = useGoTo();
  const { hasPaymentsScope } = useAuthorizedScopeGroups();
  const [resendInvite, resendInviteMeta] = useMutationResendPayeeInvite();

  return ({
    payee,
    backPath
  }: {
    payee: IPayeeResponse | IPayeeRow;
    backPath: string;
  }) => {
    const names = getPayeeNames(payee);
    const isInactive =
      payee.payerOwnedData.status === PayerPayeeStatus.Inactive;

    const headerActions: WSPageToolbarAction[] = [
      ...(isInactive || !hasPaymentsScope
        ? []
        : ([
            {
              label: "Create payable",
              icon: "plus",
              disabled: isOrgContext,
              buttonKind:
                payee.user?.status === UserStatus.Pending
                  ? undefined
                  : "Primary",
              onClick: () => {
                history.push("/member/invoices/payables/create", {
                  backPath,
                  email: names.email
                });
              }
            }
          ] as const)),
      ...(isInactive
        ? ([
            {
              label: "Restore",
              onAsyncClick: async () => {
                await updatePayee(
                  {
                    payeeId: payee.payeeId,
                    payerOwnedData: {
                      status: PayerPayeeStatus.Active
                    }
                  },
                  {
                    onSuccess: () => {
                      openSnackbar({
                        duration: 5000,
                        type: "success",
                        message: "Contractor restored successfully"
                      });
                    },
                    onError: () => {
                      openSnackbar({
                        duration: 5000,
                        type: "warning",
                        message: `Failed to restore contractor`
                      });
                    }
                  }
                );
              },
              icon: "repeat-circle"
            }
          ] as const)
        : ([
            ...(payee.user?.status === UserStatus.Pending
              ? [
                  {
                    label: "Resend invite",
                    buttonKind: "Primary",
                    onAsyncClick: async () => {
                      await resendInvite(payee.payeeId);
                    },
                    icon: "send"
                  }
                ]
              : []),
            ...(isPayeeProvidedInfo(payee)
              ? []
              : [
                  {
                    label: "Edit contractor",
                    onClick: () => {
                      goTo(buildPayeeEditTaxInfoPath(payee.payeeId));

                      // modalEditContractor.open({
                      //   payee: queryPayeeData
                      // });
                    },
                    icon: "edit"
                  }
                ]),
            {
              label: "Archive contractor",
              onClick: () => {
                modalArchiveContractor.open({
                  payeeId: payee.payeeId
                });
              },
              icon: "archive"
            },
            {
              label: "Edit internal notes",
              onClick: () => {
                modalInternalNotes.open({
                  payee: payee
                });
              },
              icon: "edit"
            },
            // {
            //   label: "Delete contractor",
            //   onClick: () => {
            //     history.push(`${match.url}/delete`);
            //   },
            //   destructive: true,
            //   icon: "trash"
            // },
            ...(isEngagementsActive
              ? [
                  {
                    label: "Add engagement",
                    onClick: () => {
                      modalAddEngagement.open({
                        payeeId: payee.payeeId
                      });
                    },
                    icon: "plus"
                  }
                ]
              : [])
          ] as WSPageToolbarAction[]))
    ];

    return headerActions;
  };
};
